export default {
  namespaced: true,
  state () {
    return {
      selectedService: null,
      selectedServiceAvailable: false,
    };
  },
  getters: {
    selectedService (state) {
      return state.selectedService;
    },
    selectedServiceAvailable (state) {
      return state.selectedServiceAvailable;
    },
  },
  actions: {
    reset ({ commit }) {
      return commit('resetRequest');
    },
  },
  mutations: {
    setSelectedService (state, data) {
      state.selectedService = data;
    },
    setSelectedServiceAvailable (state, data) {
      state.selectedServiceAvailable = data;
    },
    resetRequest (state) {
      state.selectedService = null;
      state.selectedServiceAvailable = false;
    },
  },
};
